<template>
  <div class="mx-auto">
    <RouterView></RouterView>
  </div>
</template>
